module.exports = __webpack_public_path__ + "static/img/icon-edit.31891ae3.png";